<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>On-Grid Solar System</h2>

            <ul>
                <li>
                    <a routerLink="/">Home</a>
                </li>
                <li>Solar Solutions</li>
                <li>On-Grid Solar System</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<section class="services-details-area ptb-100">
    <div class="container">
        <div class="services-details-overview">
            <div
                class="services-details-image wow animate__animated animate__fadeInUp"
            >
                <img
                    src="assets/image/on-grid-1.png"
                    alt="On-Grid Solar System"
                />
            </div>
            <div class="services-details-desc">
                <span>On-Grid Solar Solutions</span>
                <h3>
                    Generate Clean Solar Power While Staying Connected to the
                    Grid
                </h3>
                <p>
                    An on-grid solar system is a grid-connected solar power
                    solution that allows you to generate electricity from
                    sunlight and use it to meet your daily energy requirements.
                </p>
                <p>
                    The system works alongside the electricity grid, allowing
                    solar energy to be used when available while the grid can
                    support your power requirements when solar generation is
                    insufficient.
                </p>
                <ul class="features-list">
                    <li>
                        <i class="bx bx-check-double"></i>
                        Reduce Dependence on Grid Electricity
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Generate Clean Solar Energy
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Customized System Design
                    </li>
                    <li>
                        <i class="bx bx-check-double"></i>
                        Net-Metering Support
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- What Is an Off-Grid Solar System? -->
<section class="features-area ptb-100 bg-f7f9fc">
    <div class="container">
        <div class="section-title">
            <span>Understanding On-Grid Solar</span>
            <h2>How Does an On-Grid Solar System Work?</h2>
            <p>
                A smart grid-connected solar solution that lets you generate
                clean electricity, reduce your dependence on grid power, and
                make better use of your rooftop.
            </p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <span class="card-number">01</span>
                    <h3>Generate Solar Power</h3>
                    <p>
                        Solar panels convert sunlight into electricity that can
                        be used to meet your home's or business's daytime energy
                        requirements.
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-bolt-circle"></i>
                    </div>
                    <span class="card-number">02</span>
                    <h3>Use Solar Energy</h3>
                    <p>
                        The electricity generated by your solar system can power
                        appliances and equipment, helping reduce the amount of
                        electricity you need to purchase from the grid.
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="solar-info-card">
                    <div class="solar-card-icon">
                        <i class="bx bx-transfer"></i>
                    </div>
                    <span class="card-number">03</span>
                    <h3>Export Excess Power</h3>
                    <p>
                        Where applicable, surplus solar electricity can be
                        exported to the grid through an approved net-metering
                        arrangement.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- System Components -->
<section class="solar-components-area ptb-100 bg-fafafa">
    <div class="container">
        <div class="section-title">
            <span>System Components</span>
            <h2>What Makes an On-Grid Solar System?</h2>
            <p>
                Every component works together to generate solar electricity,
                connect your system with the grid, and deliver power
                efficiently.
            </p>
        </div>
        <div class="solar-components-list">
            <!-- 01 -->
            <div class="solar-component-item">
                <div class="component-number">01</div>
                <div class="component-icon">
                    <i class="bx bx-sun"></i>
                </div>
                <div class="component-content">
                    <h3>Solar Panels</h3>
                    <p>
                        Capture sunlight and convert it into DC electricity for
                        use within your home, business, or facility.
                    </p>
                </div>
            </div>
            <!-- 02 -->
            <div class="solar-component-item">
                <div class="component-number">02</div>
                <div class="component-icon">
                    <i class="bx bx-transfer"></i>
                </div>
                <div class="component-content">
                    <h3>Grid-Tied Inverter</h3>
                    <p>
                        Converts the DC electricity generated by solar panels
                        into usable AC electricity for your electrical loads.
                    </p>
                </div>
            </div>
            <!-- 03 -->
            <div class="solar-component-item">
                <div class="component-number">03</div>
                <div class="component-icon">
                    <i class="bx bx-plug"></i>
                </div>
                <div class="component-content">
                    <h3>Grid Connection</h3>
                    <p>
                        Connects the solar installation with the utility grid,
                        allowing electricity to flow between the system and
                        grid.
                    </p>
                </div>
            </div>
            <!-- 04 -->
            <div class="solar-component-item">
                <div class="component-number">04</div>
                <div class="component-icon">
                    <i class="bx bx-transfer-alt"></i>
                </div>
                <div class="component-content">
                    <h3>Net Metering</h3>
                    <p>
                        Where approved and applicable, a bidirectional meter
                        records electricity imported from and exported to the
                        grid.
                    </p>
                </div>
            </div>
            <!-- 05 -->
            <div class="solar-component-item">
                <div class="component-number">05</div>
                <div class="component-icon">
                    <i class="bx bx-layer"></i>
                </div>
                <div class="component-content">
                    <h3>Mounting Structure</h3>
                    <p>
                        Provides secure support for solar panels and helps
                        position them for effective sunlight exposure.
                    </p>
                </div>
            </div>

            <!-- 06 -->
            <div class="solar-component-item">
                <div class="component-number">06</div>
                <div class="component-icon">
                    <i class="bx bx-shield-quarter"></i>
                </div>
                <div class="component-content">
                    <h3>Safety & Protection</h3>
                    <p>
                        Cables, connectors, earthing, isolators, and protection
                        devices help ensure safe and reliable system operation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Ideal Applications -->
<section class="features-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Ideal Applications</span>
            <h2>Where Does On-Grid Solar Make Sense?</h2>
            <p>
                On-grid solar is a practical choice for homes and businesses
                looking to generate clean electricity and reduce their
                dependence on conventional grid power.
            </p>
        </div>

        <div class="row">
            <!-- Residential -->
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-home"></i>
                    </div>
                    <h3>Residential Rooftops</h3>
                    <p>
                        Generate solar electricity for your home and reduce the
                        amount of power purchased from the electricity grid.
                    </p>
                </div>
            </div>

            <!-- Commercial -->
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bx-buildings"></i>
                    </div>
                    <h3>Commercial Buildings</h3>
                    <p>
                        Help offices, shops, and commercial properties manage
                        daytime electricity consumption with rooftop solar.
                    </p>
                </div>
            </div>

            <!-- Industrial -->
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bxs-factory"></i>
                    </div>
                    <h3>Industrial Facilities</h3>
                    <p>
                        Generate renewable electricity for industrial operations
                        and help reduce long-term energy costs.
                    </p>
                </div>
            </div>

            <!-- Institutions -->
            <div class="col-lg-3 col-md-6">
                <div class="single-featured-solutions">
                    <div class="features-icon">
                        <i class="bx bxs-school"></i>
                    </div>
                    <h3>Institutions</h3>
                    <p>
                        Suitable for schools, hospitals, and other institutions
                        with suitable rooftops and regular electricity demand.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Grid Integration & Net Metering -->
<section class="battery-storage-area ptb-100">
    <div class="container">
        <div class="battery-storage-box">
            <!-- Left Content -->
            <div class="battery-content">
                <span class="section-tag"> Smart Grid-Connected Solar </span>
                <h2>Generate More Solar. Use More Clean Energy.</h2>
                <p>
                    An on-grid solar system works alongside the electricity
                    grid, allowing you to use solar power for your daily energy
                    requirements while remaining connected to the grid.
                </p>
                <p>
                    Where an approved net-metering arrangement is available,
                    surplus electricity generated by your solar system may be
                    exported to the grid according to applicable regulations and
                    utility requirements.
                </p>
                <a routerLink="/contact" class="btn btn-primary">
                    Explore Your Solar Options
                    <i class="flaticon-right"></i>
                </a>
            </div>
            <!-- Right Features -->
            <div class="battery-features">
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <div>
                        <h3>Generate Solar Energy</h3>
                        <p>
                            Solar panels generate clean electricity from
                            sunlight to meet your property's energy needs.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-home"></i>
                    </div>
                    <div>
                        <h3>Use Solar Power First</h3>
                        <p>
                            Generated solar electricity can be used by your
                            home's or business's connected electrical loads.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-transfer"></i>
                    </div>
                    <div>
                        <h3>Export Surplus Energy</h3>
                        <p>
                            Where permitted, excess generation can be exported
                            to the grid through an approved metering
                            arrangement.
                        </p>
                    </div>
                </div>
                <div class="battery-feature">
                    <div class="battery-feature-icon">
                        <i class="bx bx-bar-chart-alt-2"></i>
                    </div>
                    <div>
                        <h3>Monitor Your Generation</h3>
                        <p>
                            Solar monitoring can help you understand system
                            generation and overall energy performance.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Why Choose On-Grid Solar -->
<section class="services-area ptb-100 bg-fafafa">
    <div class="container">
        <div class="section-title">
            <span>Why Choose On-Grid Solar?</span>
            <h2>Key Benefits of Going Solar</h2>
            <p>
                On-grid solar helps homes and businesses generate clean
                electricity, improve rooftop energy utilization, and reduce
                their reliance on conventional grid power.
            </p>
        </div>
        <div class="row">
            <!-- 01 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-money"></i>
                    </div>
                    <h3>Reduce Electricity Bills</h3>
                    <p>
                        Generate your own solar electricity and reduce the
                        amount of power you need to purchase from the grid.
                    </p>
                </div>
            </div>
            <!-- 02 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-sun"></i>
                    </div>
                    <h3>Clean Solar Energy</h3>
                    <p>
                        Generate renewable electricity from sunlight and reduce
                        your dependence on conventional power sources.
                    </p>
                </div>
            </div>
            <!-- 03 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-transfer"></i>
                    </div>
                    <h3>Grid Connectivity</h3>
                    <p>
                        Stay connected to the electricity grid while using solar
                        power to meet your energy requirements.
                    </p>
                </div>
            </div>

            <!-- 04 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-recycle"></i>
                    </div>
                    <h3>Better Energy Utilization</h3>
                    <p>
                        Make productive use of your rooftop space by generating
                        electricity where it is consumed.
                    </p>
                </div>
            </div>

            <!-- 05 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-bar-chart-alt-2"></i>
                    </div>
                    <h3>Monitor Solar Generation</h3>
                    <p>
                        Track system generation and understand how your solar
                        installation is performing over time.
                    </p>
                </div>
            </div>
            <!-- 06 -->
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="features-icon">
                        <i class="bx bx-leaf"></i>
                    </div>
                    <h3>Long-Term Energy Solution</h3>
                    <p>
                        Invest in a renewable energy solution designed to
                        support your electricity requirements for years to come.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="solar-process-area ptb-100 bg-f7f9fc">
    <div class="container">
        <div class="section-title">
            <span>Our Process</span>
            <h2>From Your Rooftop to Solar Power</h2>
            <p>
                <strong>SolarCiti</strong> follows a structured process to
                understand your energy needs, design the right on-grid system,
                and help you make the most of your solar investment.
            </p>
        </div>

        <div class="solar-process">
            <!-- Step 01 -->
            <div class="process-step">
                <div class="process-top">
                    <span>01</span>
                    <i class="bx bx-map-pin"></i>
                </div>
                <div class="process-content">
                    <h3>Site Assessment</h3>
                    <p>
                        We assess your rooftop or installation site, available
                        space, electricity usage, and solar potential.
                    </p>
                </div>
            </div>

            <!-- Step 02 -->
            <div class="process-step">
                <div class="process-top">
                    <span>02</span>
                    <i class="bx bx-ruler"></i>
                </div>
                <div class="process-content">
                    <h3>System Design</h3>
                    <p>
                        We determine the appropriate solar capacity, panel
                        layout, inverter, and system configuration for your
                        needs.
                    </p>
                </div>
            </div>

            <!-- Step 03 -->
            <div class="process-step">
                <div class="process-top">
                    <span>03</span>
                    <i class="bx bx-cog"></i>
                </div>
                <div class="process-content">
                    <h3>Installation</h3>
                    <p>
                        Our team installs the solar panels, inverter, mounting
                        structure, wiring, and required protection equipment.
                    </p>
                </div>
            </div>

            <!-- Step 04 -->
            <div class="process-step">
                <div class="process-top">
                    <span>04</span>
                    <i class="bx bx-transfer"></i>
                </div>
                <div class="process-content">
                    <h3>Grid & Net Metering Support</h3>
                    <p>
                        Where applicable, we assist with grid connection,
                        documentation, and net-metering requirements.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Start Services Details Area -->
<section class="services-details-area">
    <div class="container">
        <div class="services-details-comparison ptb-100">
            <div class="section-title">
                <span>Why Choose On-Grid Solar?</span>

                <h2>How On-Grid Solar Compares to Off-Grid</h2>

                <p>
                    On-grid solar is designed for properties with reliable
                    electricity grid access. It lets you generate clean solar
                    power, reduce grid electricity consumption, and make better
                    use of your rooftop.
                </p>
            </div>

            <div class="solar-comparison-wrapper">
                <div class="table-responsive">
                    <table class="solar-comparison-table">
                        <thead>
                            <tr>
                                <th>Feature</th>

                                <!-- Highlight On Grid -->
                                <th class="featured-column">
                                    <span class="solar-type on-grid">
                                        On-Grid Solar
                                    </span>

                                    <small>
                                        Recommended for grid-connected
                                        properties
                                    </small>
                                </th>

                                <th>
                                    <span class="solar-type off-grid">
                                        Off-Grid Solar
                                    </span>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr>
                                <td>
                                    <strong>Grid Connection</strong>
                                </td>

                                <td class="featured-column">
                                    Connected to the electricity grid
                                </td>

                                <td>Operates independently from the grid</td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Battery Storage</strong>
                                </td>

                                <td class="featured-column">
                                    Generally not required
                                </td>

                                <td>
                                    Battery storage is required for energy
                                    availability
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Electricity Cost</strong>
                                </td>

                                <td class="featured-column">
                                    Can help reduce electricity bills by
                                    generating solar power
                                </td>

                                <td>
                                    Can reduce dependence on grid electricity
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Excess Solar Energy</strong>
                                </td>

                                <td class="featured-column">
                                    May be exported to the grid through an
                                    approved net-metering arrangement
                                </td>

                                <td>Stored in batteries for later use</td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>During Grid Outage</strong>
                                </td>

                                <td class="featured-column">
                                    Typically does not provide backup unless
                                    specifically designed for it
                                </td>

                                <td>
                                    Battery storage can provide power to
                                    connected loads
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Best Suited For</strong>
                                </td>

                                <td class="featured-column">
                                    Homes, businesses and facilities with
                                    reliable grid access
                                </td>

                                <td>
                                    Remote locations with unavailable or
                                    unreliable grid access
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <strong>Key Advantage</strong>
                                </td>

                                <td class="featured-column">
                                    <span class="status-badge positive">
                                        Lower Grid Consumption
                                    </span>
                                </td>

                                <td>
                                    <span class="status-badge neutral">
                                        Energy Independence
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

<app-faq></app-faq>